// extracted by mini-css-extract-plugin
export var colorSquare = "_ov-0";
export var danger = "_ov-5";
export var lightPink = "_ov-8";
export var neutralBlue = "_ov-7";
export var neutralYellow = "_ov-6";
export var normal = "_ov-1";
export var primary = "_ov-2";
export var primaryLight = "_ov-3";
export var solidBlack = "_ov-g";
export var solidGreen = "_ov-b";
export var solidLightBlue = "_ov-d";
export var solidNavy = "_ov-c";
export var solidOrange = "_ov-f";
export var solidPink = "_ov-e";
export var solidRed = "_ov-9";
export var solidYellow = "_ov-a";
export var success = "_ov-4";